import React from 'react'

import { formatMoney } from 'common/moneyFormatter'

interface Props {
  title: string
  description: string
  price: number
}

const SubscriptionPriceItem: React.FC<Props> = ({ title, description, price }) => {
  return (
    <div className="flex_space_between">
      <div>
        <span>{title}</span> <br />
        <span className="color-green-7 font-12 ">{description} </span>
      </div>
      <div>
        <p>{formatMoney(price)}</p>
      </div>
    </div>
  )
}

export default SubscriptionPriceItem
